module.exports = __webpack_public_path__ + "media/images/bg_check-ef415dde6e50d30818ea18ee4f184fff.svg";